module.exports = __webpack_public_path__ + "static/media/undraw_online_articles_79ff.d468a348.svg";